import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
    basketWrapper: {
        padding: "20px",
        borderRadius: "10px",
        width: "325px",
        minWidth: "308px",
        position: "relative",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    },
    activeBasketWrapper: {
        position: "absolute",
        right: "0",
        top: "0",
        height: "100vh",
        transform: "translate(0px)",
        zIndex: 1,
        backgroundColor: "var(--white)",
        borderRadius: "10px 0 0 10px",
        transform: "translateX(0px)"
    }
});